import { useEffect, useState } from 'react'
import { Text, Card, Button, BlockStack, InlineStack, Checkbox, TextField, Box, InlineGrid, Icon } from '@shopify/polaris'
import { ProductIcon } from '@shopify/polaris-icons'
import '../FreeShippingRules/style.css'
import { useDispatch, useSelector } from 'react-redux'
import { useAppBridge } from '@shopify/app-bridge-react';
import ItemList from "../ItemList";
import './style.css'
import { saveProducts } from '../actions';
import { saveFreeProducts } from '../../store/actions/shippingActions';
import { setToast } from '../../store/actions/configActions';
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';

const FreeShippingProducts = props => {
    const shopify = useAppBridge();
    const fetchJson = useAuthenticatedFetch()

    const { shop_id } = useSelector(state => state.ConfigReducer)
    const { free_products } = useSelector(state => state.ShippingReducer)
    const dispatch = useDispatch()

    // const [active, setActive] = useState(false)
    // const [option, setOption] = useState({ "id": free_products.id, shop_id, "showAsOption": free_products.showAsOption, "title": free_products.title ?? "", "description": free_products.description ?? "" })
    const [Loading] = useState({ p: {}, v: {} })
    const [processing, setProcessing] = useState(false)
    const [Data, setData] = useState({ ...free_products, shop_id })

    const { onStateChange } = props
    useEffect(() => {
        if (onStateChange) onStateChange(Data)
    }, [Data, onStateChange])

    const handleChange = obj => {
        setData(data => ({ ...data, ...obj }))
    }
    const handleSelectProduct = async () => {
        if (!props.disabled) {
            // setActive(true)
            const selected = await shopify.resourcePicker({
                type: "product",
                multiple: true,
                selectionIds: Data.initial_ids,
                filter: {
                    // hidden: true,
                    variants: true,
                    draft: true,
                    archived: true,
                },
            })
            if (selected?.length) {
                const initial_ids = []
                for (const product of selected) {
                    const ids = { id: product.id }
                    if (!product.hasOnlyDefaultVariant) {
                        ids.variants = []
                        for (const variant of product.variants) {
                            ids.variants.push({
                                id: variant.id
                            })
                        }
                    }
                    initial_ids.push(ids)
                }
                setData({ ...Data, initial_ids, "items_json": selected })
                // const data = await saveProducts({ ...Data, initial_ids, "items_json": selected })
                // if (data.free_products) {
                //     dispatch(saveFreeProducts(data.free_products))
                //     dispatch(setToast({ "active": true, "content": 'Free Products list saved successfully.', "error": false }))
                // }
            }
        } else {
            dispatch(setToast({ active: true, content: 'This feature is not available in current plan.', error: false }))
        }
    }

    const proSuffix = props.disabled ? ' (Pro)' : ''
    const hasItems = Data.items_json && Data.items_json.length

    const saveList = async () => {
        if (Data.showAsOption && Data.title === "") {
            dispatch(setToast({ "active": true, "content": 'Display Name is required.', "error": true }))
        } else {
            setProcessing(true)
            const data = await saveProducts({ ...Data }, fetchJson)
            setProcessing(false)
            if (data.free_products) {
                dispatch(saveFreeProducts(data.free_products))
                dispatch(setToast({ "active": true, "content": 'Free Products list saved successfully.', "error": false }))
            }
        }
    }

    return (
        <Card>
            <BlockStack gap="400">
                <div className="fs-rule-head">
                    <span className="fs-ico" aria-hidden="true"><Icon source={ProductIcon} /></span>
                    <span style={{ flexGrow: 1 }}>
                        <BlockStack gap="050">
                            <Text as="h2" variant="headingMd">Products Shipping Eligibility{proSuffix}</Text>
                            <Text as="p" tone="subdued">Treat selected products separately from the spending rule.</Text>
                        </BlockStack>
                    </span>
                </div>

                <BlockStack gap="300">
                    <Checkbox
                        label="Always calculate shipping for selected products"
                        checked={Data.ifPaidProducts}
                        onChange={value => handleChange({ "ifPaidProducts": value })}
                    />
                    {Data.ifPaidProducts ? null : <>
                        <Checkbox
                            label="Show it as a shipping option if the order contains items from the chosen products."
                            checked={Data.showAsOption}
                            onChange={value => handleChange({ "showAsOption": value })}
                        />
                        {Data.showAsOption ? (
                            <Box paddingInlineStart="600">
                                <InlineGrid columns={{ xs: 1, md: 2 }} gap="300">
                                    <TextField label="Display Name" type="text" autoComplete="off" placeholder={`Enter display name`} value={Data.title} onChange={value => {
                                        handleChange({ "title": value })
                                    }} />
                                    <TextField label="Description" type="text" autoComplete="off" placeholder={`Enter text here`} value={Data.description} onChange={value => {
                                        handleChange({ "description": value })
                                    }} />
                                </InlineGrid>
                            </Box>
                        ) : null}
                    </>}
                </BlockStack>

                {hasItems ? (
                    <BlockStack gap="300">
                        <InlineStack align="space-between" blockAlign="center">
                            <Text variant='headingSm' as='h3'>Selected Products{proSuffix}</Text>
                            <Button disabled={props.disabled} onClick={handleSelectProduct}>Select Products{proSuffix}</Button>
                        </InlineStack>
                        <ItemList
                            items={Data.items_json}
                            loading={Loading}
                            removeItem={async (p, v = null) => {
                                const data = { ...Data }
                                if (v !== null && data.items_json[p].variants.length > 1) {
                                    data.items_json[p].variants.splice(v, 1)
                                    data.initial_ids[p].variants.splice(v, 1)
                                } else {
                                    data.items_json.splice(p, 1)
                                    data.initial_ids.splice(p, 1)
                                }
                                setData({ ...data })
                                if (data.items_json.length < 1) {
                                    data.showAsOption = false
                                    const response = await saveProducts(data, fetchJson)
                                    if (response.status === 'updated') {
                                        dispatch(saveFreeProducts(response.free_products))
                                    }
                                }
                            }}
                        />
                        <InlineStack align="end">
                            <Button variant='primary' loading={processing} disabled={processing} onClick={saveList}>{Data.id ? 'Update' : 'Save'}</Button>
                        </InlineStack>
                    </BlockStack>
                ) : (
                    <div className="fs-picker">
                        <span style={{ flex: '1 1 240px' }}>
                            <BlockStack gap="050">
                                <Text as="span" fontWeight="semibold">There are no products selected</Text>
                                <Text as="span" tone="subdued">Selected products will not be calculated for free shipping on minimum spent.</Text>
                            </BlockStack>
                        </span>
                        <Button disabled={props.disabled} onClick={handleSelectProduct}>Select Products{proSuffix}</Button>
                    </div>
                )}
            </BlockStack>
        </Card>
    )
}

export default FreeShippingProducts
